<pw-view-title>{{'contacts.contactsList.contacts' | translate}}</pw-view-title>

<div class="ps-flex-container-col">
  <mat-nav-list>
    <mat-list-item *ngFor="let supplier of suppliers$ | async" routerLink="/suppliers/{{supplier.OBJECT_ID}}">
      <span mat-line>{{supplier.TEXT}}</span>
    </mat-list-item>
  </mat-nav-list>
</div>
